import { pm2ConfigStore } from '@pm2/store';
import { makeTanstackQuery } from '@provider/tanstack';
import { useUserIdentityState } from '@provider/user-identity';
import { configRefs, DAYS_TO_MS } from '@utils/constants';
import { getInternalKeyForFavouriteDescriptor } from '../util.get-internal-key.js';
import { getFavouriteDataRequest } from './get-data.request.js';

const getFavouriteDataQuery = makeTanstackQuery({
  defaultQueryConfig: {
    staleTime: 1 * DAYS_TO_MS,
    gcTime: 21 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  },
  queryKey: input => ["user-area/favourites/get-data", configRefs.env.app.dangerouslyAssertSyncValue(), input.user?.id, getInternalKeyForFavouriteDescriptor(input.descriptor)],
  queryFn: input => {
    if (!input.user) {
      return null;
    }
    return getFavouriteDataRequest(input.configStore.getState(), input.descriptor);
  },
  useQueryInput(queryFactory, externalInput) {
    const user = useUserIdentityState(state => state.user);
    const configStore = pm2ConfigStore.useStore();
    return queryFactory({
      user,
      configStore,
      ...externalInput
    });
  }
});

export { getFavouriteDataQuery };
//# sourceMappingURL=get-data.query.js.map
